const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';

export const AUTH = {
  LOGIN: `${BASE}/auth/login`,
  REFRESH: `${BASE}/auth/refresh`,
  VALIDATE: `${BASE}/auth/validate`,
  BITRIX_SSO: `${BASE}/auth/bitrix-sso`,
} as const;

export const CATALOGS = {
  DISCOVER: `${BASE}/marketplace/catalogs`,
} as const;

export const CREDENTIALS = {
  LIST: `${BASE}/marketplace/credentials`,
  SAVE: `${BASE}/marketplace/credentials/bitrix`,
  DELETE: (marketplace: string) => `${BASE}/marketplace/credentials/${marketplace}`,
} as const;

export const COMMERCE = {
  // Catalog sync
  SYNC_START: `${BASE}/commerce-audit/sync/bitrix/start`,
  SYNC_STATUS: `${BASE}/commerce-audit/sync/bitrix/status`,
  SYNC_CANCEL: `${BASE}/commerce-audit/sync/bitrix/cancel`,

  // AI analysis
  ANALYZE_START: `${BASE}/commerce-audit/analyze/bitrix/start`,
  ANALYZE_STATUS: `${BASE}/commerce-audit/analyze/bitrix/status`,
  ANALYZE_CANCEL: `${BASE}/commerce-audit/analyze/bitrix/cancel`,
  ANALYZE_PRODUCT: (id: string) => `${BASE}/commerce-audit/analyze/bitrix/${id}`,

  // Review analysis (no data for Bitrix — runs but finds nothing)
  REVIEWS_START: `${BASE}/commerce/review-analysis/start`,
  REVIEWS_STATUS: `${BASE}/commerce/review-analysis/status`,
  REVIEW_SUMMARY: (id: string) => `${BASE}/commerce/review-analysis/products/${id}/review-summary`,

  // Products
  PRODUCTS: `${BASE}/commerce-audit/products/bitrix`,
  PRODUCT: (id: string) => `${BASE}/commerce-audit/products/bitrix/${id}`,

  // Scores
  SCORES: `${BASE}/commerce-audit/scores/bitrix`,
  SCORE_IDS: `${BASE}/commerce-audit/scores/bitrix/ids`,
  PRODUCT_SCORE: (id: string) => `${BASE}/commerce-audit/scores/bitrix/${id}`,

  // Summaries & stats
  SUMMARY: `${BASE}/commerce-audit/summary/bitrix`,
  KPI: `${BASE}/commerce-audit/kpi/bitrix`,
  STATS: `${BASE}/commerce-audit/stats/bitrix`,

  // Batch content actions
  ACTION_SINGLE: `${BASE}/commerce-audit/actions/single`,
  ACTION_BATCH: `${BASE}/commerce-audit/actions/batch`,
  ACTION_BATCH_STATUS: (jobId: string) => `${BASE}/commerce-audit/actions/batch/${jobId}`,
  ACTION_BATCH_RESULTS: (jobId: string) => `${BASE}/commerce-audit/actions/batch/${jobId}/results`,
  ACTION_BATCH_APPROVE: (jobId: string) => `${BASE}/commerce-audit/actions/batch/${jobId}/approve`,
  ACTION_BATCH_PUBLISH_STATUS: (jobId: string) =>
    `${BASE}/commerce-audit/actions/batch/${jobId}/publish-status`,
  ACTION_BATCH_CANCEL: (jobId: string) => `${BASE}/commerce-audit/actions/batch/${jobId}/cancel`,

  // Action history & rollback
  ACTION_HISTORY: `${BASE}/commerce-audit/actions/history`,
  ACTION_DIFF: (actionId: string) => `${BASE}/commerce-audit/actions/${actionId}/diff`,
  ACTION_ROLLBACK: (actionId: string) => `${BASE}/commerce-audit/actions/${actionId}/rollback`,
} as const;

export const TASKS = {
  LIST: `${BASE}/tasks`,
  CREATE: `${BASE}/tasks`,
  DETAIL: (id: string) => `${BASE}/tasks/${id}`,
  CLARIFY: (id: string) => `${BASE}/tasks/${id}/clarify`,
  APPROVE: (id: string) => `${BASE}/tasks/${id}/approve`,
  REJECT: (id: string) => `${BASE}/tasks/${id}/reject`,
  PAUSE: (id: string) => `${BASE}/tasks/${id}/pause`,
  RESUME: (id: string) => `${BASE}/tasks/${id}/resume`,
  CANCEL: (id: string) => `${BASE}/tasks/${id}/cancel`,
  STEPS: (id: string) => `${BASE}/tasks/${id}/steps`,
  STEP_APPROVE: (id: string, stepId: string) => `${BASE}/tasks/${id}/steps/${stepId}/approve`,
  STEP_EDIT: (id: string, stepId: string) => `${BASE}/tasks/${id}/steps/${stepId}/edit`,
  DIFFS: (id: string) => `${BASE}/tasks/${id}/diffs`,
  IMPACT: (id: string) => `${BASE}/tasks/${id}/impact`,
  APPROVALS_PENDING: `${BASE}/tasks/approvals/pending`,
  APPROVAL_DECIDE: (id: string) => `${BASE}/tasks/approvals/${id}/decide`,
} as const;

export const SUBSCRIPTION = {
  STATUS: `${BASE}/marketplace/subscription`,
} as const;

export const TELEGRAM = {
  GENERATE_LINK: `${BASE}/telegram/generate-link-token`,
  STATUS: `${BASE}/telegram/status`,
} as const;

export const BITRIX_STORE = {
  CATALOGS: `${BASE}/bitrix-store/catalogs`,
  SETUP: `${BASE}/bitrix-store/setup`,
  ORDERS: `${BASE}/bitrix-store/orders`,
  ORDER_DETAIL: (id: string) => `${BASE}/bitrix-store/order/${id}`,
  DASHBOARD: `${BASE}/bitrix-store/dashboard`,
  LOW_STOCK: `${BASE}/bitrix-store/low-stock`,
  WEEKLY_TRENDS: `${BASE}/bitrix-store/weekly-trends`,
} as const;
